import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AdminRoute = () => {
  const location = useLocation();

  // خواندن مستقیم role از localStorage
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  // اگر توکن نداشت یا نقشش ادمین نبود
  const isAdmin = token && role === "admin";

  if (!isAdmin) {
    return (
      <Navigate to="/panel/user" replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet />;
};

export default AdminRoute;
